import { array, boolean, date, number, object, string } from "yup";

const YUP = { object, string, number, date, array, boolean };

export default YUP;
